import { useQuery } from '@tanstack/react-query';

import { api } from '@shared/api/client';
import { key, STALE_TIME } from '@shared/api/query-keys';

import type { Page, PaymentGateway } from '../_shared/types';

/**
 * The provider registry.
 *
 * **The list renders name, state, fee, and callback endpoint — never a
 * credential, in any form.** The row carries the *name of the configuration key*
 * that holds the secret, which is what the rotation dialog writes to; the secret
 * itself has no read path from this bundle or from any other.
 *
 * `staleTime` is the list default rather than the vocabulary one: which gateway
 * is bound is the sharpest operational fact on this surface, and an operator
 * returning to the tab after a colleague activated another one must not see the
 * previous binding.
 */
export function paymentGatewaysKey() {
  return key('finance', 'paymentGateways');
}

export function usePaymentGateways() {
  return useQuery({
    queryKey: paymentGatewaysKey(),
    queryFn: () => api.get<Page<PaymentGateway>>('finance', '/admin/paymentGateways'),
    staleTime: STALE_TIME.list,
  });
}
